<template>
  <div class="commonTable">
    <el-table :data="tableData" tooltip-effect="light">
      <el-table-column prop="orderCode" label="订单号" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="createTimeStr" label="划扣时间" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="vipCardName" label="划扣套餐" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <yz-btn type="primary" @click="orderDetails(scope.row.id)">详情</yz-btn>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="tableData.length > 0" class="blockThree">
      <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <el-dialog :title="'划扣详情-订单号：'+orderCode" :visible.sync="buckleDeatilsDialog" :append-to-body="true" width="800px">
      <div class="order-details">
        <div class="box" style="padding-bottom:30px;">
          <div class="title">顾客信息</div>
          <div class="userInfo">
            <div class="userLi">
              <img :src="buckleDeatilsData.headImgUrl || 'static/images/head.png'" />
              <h1>姓名：{{ buckleDeatilsData.clientName || '--' }}</h1>
              <h2>联系电话：{{ buckleDeatilsData.phone || '--' }}</h2>
            </div>
            <div class="userLi">
              <h3>
                会员卡号：
                <span>{{ buckleDeatilsData.memberNo || '--' }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="box">
          <div style="padding-bottom:30px;">
            <div class="title">划扣信息</div>
            <div class="box" style="padding-bottom: 0;">
              <div class="titleNone">划扣时间：{{ buckleDeatilsData.createTimeStr }}</div>
            </div>
            <div class="box" style="padding-bottom: 0;">
              <div class="titleNone">划扣套餐：{{ buckleDeatilsData.vipCardName }}</div>
            </div>
            <el-table tooltip-effect="light" :data="buckleDeatilsData.vipCardOrderItemList">
              <el-table-column prop="dictItemName" label="划扣服务" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column label="上次剩余数量" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.lastResidueCount }}次</span>
                </template>
              </el-table-column>
              <el-table-column label="划扣数量" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.count }}次</span>
                </template>
              </el-table-column>
              <el-table-column label="剩余次数" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.residueCount }}次</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPackageUseListByPhone, getOnePackageUseDetailByPhone } from '../api';

export default {
  data() {
    return {
      phone: '', // 顾客手机
      tableData: [], // 预约列表信息
      pageNum: 1, // 列表页码
      rowCount: 1, // 列表总数
      buckleDeatilsDialog: false, // 充值详情-弹出框
      orderDeatilsData: {},
      orderCode: '',
      buckleDeatilsData: {},
    };
  },
  activated() {
    this.phone = window.sessionStorage.customerPhone;
    this.getListData(1);
  },
  methods: {
    getListData(val) {
      this.pageNum = val;
      const data = {
        pageNum: this.pageNum,
        phone: this.phone
      };
      getPackageUseListByPhone(data).then((res) => {
        this.tableData = res.data.records;
        this.rowCount = res.data.total;
        this.pageSize = res.data.size;
      });
    },
    handleSizeChange(val) {
      this.getListData(val);
    },
    handleCurrentChange(val) {
      this.getListData(val);
    },
    orderDetails(id) {
      const data = {
        orderId: id
      };
      getOnePackageUseDetailByPhone(data).then((res) => {
        if (res.code === 0) {
          this.buckleDeatilsData = res.data;
          this.buckleDeatilsDialog = true;
          this.orderCode = res.data.orderCode;
        }
      });
    }
  }
};
</script>
